import api from '@/services/api';
import { make } from 'vuex-pathify';

const state = {
  digitizationTypes: [],
};

const mutations = {
  ...make.mutations(state),
  SET_DIGITIZATION_TYPES(state, types) {
    state.digitizationTypes = Object.entries(types).reduce((acc, [value, text]) => [...acc, { value, text }], []);
  },
};

const actions = {
  async getDigitizationTypes({ commit }) {
    const r = await api.get('automatic_digitization');
    commit('SET_DIGITIZATION_TYPES', r.data.data);
  },
  async getDigitizationResults(store, data) {
    const { digitizationType, onlyValidation = false, payload, params } = data;
    const r = await api.post(`automatic_digitization/${digitizationType}`, payload, {
      params: { ...params, ...(onlyValidation ? { validate: true } : { background: true }) },
    });
    return r?.data?.tid;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
